import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ standalone: true, name: 'severiteLabel' })
export class SeveritePipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'FAIBLE':
        return 'Faible';
      case 'MOYENNE':
        return 'Moyenne';
      case 'ELEVEE':
        return 'Élevée';
      case 'TRES_ELEVEE':
        return 'Très Élevée';
      default:
        return value;
    }
  }
}
